import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { Branch } from '../models/branch.model';

@Injectable({ providedIn: 'root' })
export class BranchesService {
  http = inject(HttpClient);

  getList(): Observable<Branch[]> {
    return this.http.get<Branch[]>('Branches');
  }
}
